import { Injectable, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { add_to_cart_option_interface } from './google-analytics.model';
import { LanguageService } from '../../language.service';



declare let gtag: any;



@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService implements OnInit
{


  currencyCode: string = 'haha';
  lang =  'en';


  constructor(
    private router: Router,
    private language_s: LanguageService
  ){}


  ngOnInit(): void
  {

    ;

  }



  handleClientId()
  {
    this.router.events.subscribe({
      next: (resopnse) => {
        if (resopnse instanceof NavigationStart) {
          this.pageView({ client_id: '21', language: this.lang });
        }
      },
    });
  }


  pageView(params: any)
  {
    console.log(params, 'params');

    if (typeof gtag !== 'undefined') {
      gtag('event', 'page_view', params);
    }
  }


  addToCart(addToCartParams: add_to_cart_option_interface)
  {
    if (typeof gtag !== 'undefined') {

      gtag('event', 'add_to_cart', addToCartParams);
    }
  }


  RemoveFromCart(product: any, quantity: any, price: any)
  {


    if (typeof gtag !== 'undefined') {
      var addToCartParams = {
        currency: this.currencyCode,
        value: 0,
        items: [
          {
            item_id: JSON.stringify(product.id),
            item_name: product.name,
            item_category: product.category.name,
            price,
            quantity,
          },
        ],
      };
      console.log(addToCartParams);

      gtag('event', 'remove_from_cart', addToCartParams);
    }
  }


  AddToWishlist(price: any, item_id: any, item_name: any, item_category: any)
  {


    if (typeof gtag !== 'undefined') {
      var addToCartParams = {
        currency: this.currencyCode,
        items: [
          {
            item_id,
            item_name,
            item_category,
            price,
          },
        ],
      };
      gtag('event', 'add_to_wishlist', addToCartParams);
    }


  }


  BeginCheckout(total: any, cart: any)
  {


    if (typeof gtag !== 'undefined') {
      let items = (cart as Array<any>).map((item) => {
        return {
          item_id: item.product.id,
          item_name: item.product.name,
          item_category: item.product.category.name,
          quantity: item.quantity,
          price: item.price,
        };
      });
      var BeginCheckoutParams = {
        currency: this.currencyCode,
        value: total,
        items,
      };
      gtag('event', 'begin_checkout', BeginCheckoutParams);
    }

  }


  Login(method: any)
  {

    if (typeof gtag !== 'undefined') {
      var LoginParams = {
        method,
      };
      gtag('event', 'login', LoginParams);
    }

  }


  SignUp(method: any)
  {

    if (typeof gtag !== 'undefined') {
      var LoginParams = {
        method,
      };
      gtag('event', 'sign_up', LoginParams);
    }

  }


  ViewCart()
  {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'view_cart');
    }
  }


  purchase(params: any) {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'purchase', params);
    }
  }

  search(text: any) {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'search', { text });
    }

  }

  addPaymentInfo(params: any) {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'add_payment_info', params);
    }
  }

  addShippingInfo(params: any) {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'add_shipping_info', params);
    }
  }

}
